import { render, staticRenderFns } from "./PublicEventoList.vue?vue&type=template&id=b7ae6d3a&scoped=true"
import script from "./PublicEventoList.vue?vue&type=script&lang=js"
export * from "./PublicEventoList.vue?vue&type=script&lang=js"
import style0 from "./PublicEventoList.vue?vue&type=style&index=0&id=b7ae6d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ae6d3a",
  null
  
)

export default component.exports